<div class="bg-lGray950 light:bg-lGray900 border border-lGray800 rounded-3xl p-6 h-full min-h-[13rem] aspect-[5/4] xl:aspect-auto flex flex-col justify-between">
  <div class="flex items-center gap-2.5 min-w-0">
    <l-icon class="text-xl leading-none shrink-0" [class]="iconColorClass">{{ metric.icon }}</l-icon>
    <p class="text-lWhite text-base font-medium leading-tight">{{ metric.title }}</p>
  </div>

  <div class="min-w-0 mt-6">
    <p class="text-lSecondary text-sm leading-none mb-2">{{ metric.period }}</p>
    <p class="text-lWhite text-base font-semibold leading-snug line-clamp-3">{{ metric.value }}</p>
  </div>
</div>
